/** @module Enums */ /** typedoc */
/**
 *
 * Zero-decimal currencies (https://support.stripe.com/questions/which-zero-decimal-currencies-does-stripe-support)

 - BIF: Burundian Franc
 - CLP: Chilean Peso
 - DJF: Djiboutian Franc
 - GNF: Guinean Franc
 - JPY: Japanese Yen
 - KMF: Comorian Franc
 - KRW: South Korean Won
 - MGA: Malagasy Ariary
 - PYG: Paraguayan Guaraní
 - RWF: Rwandan Franc
 - VND: Vietnamese Đồng
 - VUV: Vanuatu Vatu
 - XAF: Central African Cfa Franc
 - XOF: West African Cfa Franc
 - XPF: Cfp Franc
 */
var ZeroDecimalCurrenciesEnum;
(function (ZeroDecimalCurrenciesEnum) {
    ZeroDecimalCurrenciesEnum["BIF"] = "BIF";
    ZeroDecimalCurrenciesEnum["DJF"] = "DJF";
    ZeroDecimalCurrenciesEnum["JPY"] = "JPY";
    ZeroDecimalCurrenciesEnum["KRW"] = "KRW";
    ZeroDecimalCurrenciesEnum["PYG"] = "PYG";
    ZeroDecimalCurrenciesEnum["VND"] = "VND";
    ZeroDecimalCurrenciesEnum["XAF"] = "XAF";
    ZeroDecimalCurrenciesEnum["XPF"] = "XPF";
    ZeroDecimalCurrenciesEnum["CLP"] = "CLP";
    ZeroDecimalCurrenciesEnum["GNF"] = "GNF";
    ZeroDecimalCurrenciesEnum["KMF"] = "KMF";
    ZeroDecimalCurrenciesEnum["MGA"] = "MGA";
    ZeroDecimalCurrenciesEnum["RWF"] = "RWF";
    ZeroDecimalCurrenciesEnum["VUV"] = "VUV";
    ZeroDecimalCurrenciesEnum["XOF"] = "XOF";
})(ZeroDecimalCurrenciesEnum || (ZeroDecimalCurrenciesEnum = {}));

export { ZeroDecimalCurrenciesEnum };
